"use client";

import Image, { StaticImageData } from "next/image";
import React from "react";

type MembershipCardProps = {
  logo: StaticImageData | string;
  subtitle: string;
  title: string;
  logoWidth?: number;
  logoHeight?: number;
};

export default function MembershipCard({
  logo,
  subtitle,
  title,
  logoWidth = 206,
  logoHeight = 55,
}: MembershipCardProps) {
  return (
    <div className="group relative border border-[#ecf0f6] bg-white w-full h-full overflow-hidden transition-colors duration-300 hover:border-[#d9e2ed]">
      {/* Top-left accent */}
      <span className="absolute top-0 left-0 h-[2px] w-0 bg-[#225BD4] transition-all duration-500 ease-out group-hover:w-[40px]" />
      <span className="absolute top-0 left-0 w-[2px] h-0 bg-[#225BD4] transition-all duration-500 ease-out group-hover:h-[40px]" />

      {/* Bottom-right accent */}
      <span className="absolute bottom-0 right-0 h-[2px] w-0 bg-[#225BD4] transition-all duration-500 ease-out group-hover:w-[40px]" />
      <span className="absolute bottom-0 right-0 w-[2px] h-0 bg-[#225BD4] transition-all duration-500 ease-out group-hover:h-[40px]" />

      <div className="flex flex-col items-center justify-start gap-6 px-10 py-10">
        {/* Logo */}
        <div className="flex items-center justify-center min-h-[60px]">
          <Image
            src={logo}
            alt={title}
            width={logoWidth}
            height={logoHeight}
            className="w-[80px] sm:w-[110px] md:w-[120px] lg:w-auto object-contain transition-transform duration-500 ease-out group-hover:scale-[1.03]"
            sizes="(max-width: 640px) 140px, (max-width: 768px) 170px, (max-width: 1024px) 190px, 206px"
            loading="lazy"
          />
        </div>

        {/* Content */}
        <div className="flex flex-col items-center justify-start gap-2">
          <p className="text-[#636364] text-[15px] leading-[140%] font-[500] text-center max-w-[32ch]">
            {subtitle}
          </p>

          <h3 className="text-[#00040b] text-[15px] leading-[120%] font-semibold text-center max-w-[32ch] transition-colors duration-300 group-hover:text-[#225BD4]">
            {title}
          </h3>
        </div>
      </div>
    </div>
  );
}
